import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ticket, TicketFarben } from '../../../../../projects/kiene-core/src/lib/classes/ticket';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { DateTableColumn, StatusTableColumn, TableColumn } from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { TableOption } from '../../../components/kiene-table/table-option';
import {
    FilterItem,
    FilterItemType,
} from '../../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';

@Component({
    selector: 'kiene-ticket-uebersicht-historie',
    templateUrl: './ticket-uebersicht-historie.component.html',
    styleUrls: ['./ticket-uebersicht-historie.component.scss'],
})
export class TicketUebersichtHistorieComponent implements OnInit {
    historyTableDescriptor = new TableDescriptor();
    isAdmin = false;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private router: Router,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        this.isAdmin = this.localStorageService.currentUserIsAdmin();
        this.initHistoryTable();
    }

    initHistoryTable() {
        this.historyTableDescriptor.headline = 'Ticket Historie';
        this.historyTableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'ticket/read_eingespielt.php';

        this.historyTableDescriptor.initialSortDirection = 'desc';
        this.historyTableDescriptor.initialSortColumn = 'editiert';
        this.historyTableDescriptor.nameOfIdField = 'ticket_id';
        this.historyTableDescriptor.uniqueIdentifier = 'TicketsHistorie';
        this.historyTableDescriptor.defaultPageSize = 20;

        this.historyTableDescriptor.showDetailsVoid = this.gotoDetails.bind(this);
        this.historyTableDescriptor.sendCurrentClient = true;
        this.historyTableDescriptor.createAllowed = false;

        this.historyTableDescriptor.permissionView = 10031;

        this.historyTableDescriptor.columns = this.getHistoryColumns();
        this.historyTableDescriptor.options = this.getOpenOptions();

        this.historyTableDescriptor.filterItems.push(
            new FilterItem('Abgelehnt', 226, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.historyTableDescriptor.filterItems.push(
            new FilterItem('Eingespielt', 229, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.historyTableDescriptor.filterItems.push(
            new FilterItem('Obsolet', 230, FilterItemType.CHECKBOX, 'status_id', true),
        );
    }

    getHistoryColumns() {
        const columns = [];

        columns.push(new TableColumn('ticket_id', 'ID', 'number'));
        if (this.localStorageService.currentUserIsAdmin()) {
            columns.push(new TableColumn('typ', 'Support-Typ'));
        }

        const valueColorMap = new Map<number, string>();
        valueColorMap.set(230, TicketFarben.getColor(230));
        valueColorMap.set(229, TicketFarben.getColor(229));
        valueColorMap.set(228, TicketFarben.getColor(228));
        valueColorMap.set(227, TicketFarben.getColor(227));
        valueColorMap.set(226, TicketFarben.getColor(226));
        valueColorMap.set(225, TicketFarben.getColor(225));
        valueColorMap.set(224, TicketFarben.getColor(224));
        columns.push(new StatusTableColumn('status', 'Status', valueColorMap));

        if (this.localStorageService.hasPermission(10044)) {
            columns.push(new TableColumn('prioritaet_bez', 'Priorität'));
        }
        columns.push(new TableColumn('titel', 'Titel'));
        columns.push(new TableColumn('ersteller', 'Ersteller'));
        columns.push(new DateTableColumn('editiert', 'Editiert'));

        return columns;
    }

    public gotoDetails(ticketInput: Ticket) {
        this.router.navigate(['/support', 'ticket-historie', ticketInput.ticket_id]).then();
    }

    private getOpenOptions(): TableOption[] {
        const options = [];
        options.push(new TableOption(this.gotoDetails.bind(this), 'Details', 'description', 10008));
        return options;
    }
}
